import { render, staticRenderFns } from "./AllChildren.vue?vue&type=template&id=a63ec1c4&scoped=true"
import script from "./AllChildren.vue?vue&type=script&lang=js"
export * from "./AllChildren.vue?vue&type=script&lang=js"
import style0 from "./AllChildren.vue?vue&type=style&index=0&id=a63ec1c4&prod&scoped=true&lang=css"
import style1 from "./AllChildren.vue?vue&type=style&index=1&id=a63ec1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ec1c4",
  null
  
)

export default component.exports